import React, {ElementRef, useRef} from 'react';
import useDebounce from 'hooks/useDebounce';

interface ISearchBarProps {
  searchString?: string;
  setSearchString?: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
}

const SearchBar: React.FC<ISearchBarProps> = ({searchString, setSearchString, placeholder}) => {
  const inputRef = useRef<ElementRef<'input'>>(null);
  const {debounce} = useDebounce();

  return (
    <section className="w-10/12 absolute top-2.5 right-5 z-10">
      <div className="w-full flex items-center h-full">
        <div className="relative w-full">
          <svg
            className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.7955 13.8111L19 19M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
              stroke="lightGray"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <input
            type="text"
            placeholder={placeholder}
            className="bg-bgColor w-full pl-10 poppins-regular text-sm placeholder-lightGray rounded-lg border-none focus:outline-none focus:ring-0 focus:border-none"
            ref={inputRef}
            onChange={async ({target}) => {
              await debounce(300);
              setSearchString && setSearchString(target.value);
            }}
          />

          {searchString && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              onClick={() => {
                setSearchString('');
                inputRef.current.value = '';
              }}
              className="absolute right-2.5 top-1/2 transform -translate-y-1/2 w-5 h-5 cursor-pointer">
              <path
                fill="#b7b7b7"
                d="M10 1.6a8.4 8.4 0 1 0 0 16.8a8.4 8.4 0 0 0 0-16.8zm4.789 11.461L13.06 14.79L10 11.729l-3.061 3.06L5.21 13.06L8.272 10L5.211 6.939L6.94 5.211L10 8.271l3.061-3.061l1.729 1.729L11.728 10l3.061 3.061z"
              />
            </svg>
          )}
        </div>
      </div>
    </section>
  );
};

export default SearchBar;
